export const IconThumbsUpOutline = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.55347 5.61719H0.553467V14.6172H3.55347V5.61719Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.55396 13.6141C6.5884 13.6141 6.83563 14.8224 10.9441 15.0692C12.0976 15.1385 12.9254 15.1982 13.6937
    14.2132C15.3809 12.0499 16.1913 6.90548 14.5548 6.90548H11.212C10.4757 6.90548 9.8787 6.30851 9.8787 5.57213V2.9788C9.8787
    0.965462 6.93343 -0.0911405 6.93343 2.16546C6.93343 3.78386 6.31676 4.89641 5.28658 5.87651C4.78266 6.35594 4.19346 6.61259
    3.55396 6.74968"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
